import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Modal from "react-modal";
import { FaArrowRight, FaXmark } from "react-icons/fa6";
import "./Blogs.css";

if (typeof window !== "undefined" && document.getElementById("root")) {
  Modal.setAppElement("#root");
}

const BLOGS_DATA = [
  {
    id: 1,
    title: "Morbi: The Ceramic Capital of India.",
    category: "Ceramics & Clusters",
    date: "July 25, 2026",
    image:
      "https://images.unsplash.com/photo-1590486803833-1c5dc8ddd4c8?auto=format&fit=crop&w=1200&q=80",
    excerpt:
      "Morbi, India is home to world's second largest ceramic production cluster which specialises in ceramic tile, sanitary ware, and technical porcelain export.",
    content:
      "Morbi in Gujarat has transformed into a global epicenter for ceramic tile and sanitary ware manufacturing. With over 800 production units, Morbi contributes over 90% of India's total ceramic export output. In this feature, we analyze global import markets across Europe, the Middle East, and North America, showcasing how advanced automation and energy-efficient kilns are propelling Morbi onto the international trade stage.",
    tags: ["#MorbiCeramics", "#GlobalExport", "#TileIndustry"],
  },
  {
    id: 2,
    title: "Vibrant Buildcon – 2025: UK Market Opens for India",
    category: "Global Trade",
    date: "July 20, 2026",
    image:
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=800&q=80",
    excerpt:
      "India and the United Kingdom have restarted FTA Talks once again as the newly elected Labour government sets bilateral trade acceleration.",
    content:
      "The Free Trade Agreement (FTA) between India and the UK opens unprecedented export corridors for Indian building material manufacturers. Lower import tariffs on steel, granite, and ceramic fittings allow Indian suppliers to seamlessly plug into major UK commercial and infrastructure projects.",
    tags: ["#UKTrade", "#FTAAgreement", "#ExportCorridors"],
  },
  {
    id: 3,
    title:
      "Vibrant Buildcon – 2025: Revitalizing Sri Lanka - India Trade Relations",
    category: "Global Trade",
    date: "July 15, 2026",
    image:
      "https://images.unsplash.com/photo-1541888946425-d0fbb186a5b3?auto=format&fit=crop&w=800&q=80",
    excerpt:
      "Sri Lanka and India strengthen bilateral construction ties with multi-million dollar port and housing infrastructure joint ventures.",
    content:
      "Sri Lanka's post-recovery infrastructure push relies heavily on Indian building materials and engineering expertise. Joint ventures in port expansion, highway modernization, and affordable housing showcase how India remains Sri Lanka's primary trade partner.",
    tags: ["#SriLankaIndia", "#InfraPartnership", "#BuildingMaterials"],
  },
  {
    id: 4,
    title: "Vibrant Buildcon – 2025: India & Egypt Trade Connections",
    category: "Global Trade",
    date: "July 08, 2026",
    image:
      "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=800&q=80",
    excerpt:
      "India and Egypt, both nations once housed great ancient civilizations, forge modern building material export channels across North Africa.",
    content:
      "Connecting the Indus-Saraswati legacy with Nile Delta urbanization, India and Egypt have signed bilateral agreements expanding cement, glass, and prefabricated housing component exports into North African markets.",
    tags: ["#EgyptTrade", "#SuezCorridor", "#GlobalInfra"],
  },
  {
    id: 5,
    title: "Vibrant Buildcon – 2025: Azerbaijan Trade Crossroads",
    category: "Global Trade",
    date: "June 28, 2026",
    image:
      "https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=800&q=80",
    excerpt:
      "Azerbaijan, strategically located at the crossroads of Europe and Asia, has been a significant player in the global trade for building materials.",
    content:
      "Azerbaijan's booming urban development in Baku creates strong demand for high-end Indian granite, marble, and architectural glass. Bharat Buildcon delegation reports record B2B buyer interest during the Baku trade expo.",
    tags: ["#Azerbaijan", "#EurasiaTrade", "#CeramicExport"],
  },
  {
    id: 6,
    title:
      "Embracing Innovation: Technology Revolution at Vibrant Buildcon 2025",
    category: "Construction Tech",
    date: "June 18, 2026",
    image:
      "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=800&q=80",
    excerpt:
      "Technology is transforming every aspect of the construction industry, and nowhere is that more evident than at Vibrant Buildcon 2025.",
    content:
      "At Vibrant Buildcon 2025, robotic bricklaying, autonomous site survey drones, and 4D BIM software stole the spotlight. Industry leaders break down how digitalization reduces project delays by up to 40%.",
    tags: ["#ConTech", "#AIConstruction", "#3DPrinting"],
  },
  {
    id: 7,
    title: "Sustainable Solutions Take Center Stage at Vibrant Buildcon 2025",
    category: "Sustainability",
    date: "June 10, 2026",
    image:
      "https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=800&q=80",
    excerpt:
      "At Vibrant Buildcon 2025, sustainability isn't just a buzzword - it's a guiding principle shaping the future of construction.",
    content:
      "From recycled aggregate concrete to solar glass facades and zero-waste site protocols, green construction methodologies took center stage at Vibrant Buildcon 2025.",
    tags: ["#Sustainability", "#GreenConcrete", "#CarbonNeutral"],
  },
  {
    id: 8,
    title: "Exploring the Future of Construction at Vibrant Buildcon 2025",
    category: "Construction Tech",
    date: "June 02, 2026",
    image:
      "https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=800&q=80",
    excerpt:
      "Welcome to Vibrant Buildcon 2025 - where innovation meets construction! We're thrilled to unveil the largest and most significant milestones.",
    content:
      "Highlights from the flagship expo including 1,000+ exhibitors, international buyer delegations, and live technical workshops on structural engineering resilience.",
    tags: ["#FutureOfInfra", "#Expo2025", "#BuildconMilestones"],
  },
];

const Blogs = () => {
  const [activeCategory, setActiveCategory] = useState("All");
  const [selectedBlog, setSelectedBlog] = useState(null);

  const categories = [
    "All",
    "Ceramics & Clusters",
    "Global Trade",
    "Construction Tech",
    "Sustainability",
  ];

  const filteredBlogs = BLOGS_DATA.filter((blog) => {
    return activeCategory === "All" || blog.category === activeCategory;
  });

  return (
    <div className="blogs-page">
      <Helmet>
        <title>Blogs | Bharat Buildcon</title>
      </Helmet>
      <div className="blogs-ambient-glow"></div>

      {/* HEADER SECTION */}
      <section className="blogs-header-container">
        <div className="clean-breadcrumb-wrapper">
          <nav className="about-style-breadcrumb" aria-label="Breadcrumb">
            <Link to="/" className="bc-home-link">
              HOME
            </Link>
            <span className="bc-slash">/</span>
            <span className="bc-active-page">BLOGS</span>
          </nav>
        </div>

        <h1 className="blogs-main-title">
          Blogs & <span className="gradient-text">Industry Insights</span>
        </h1>

        <p className="blogs-subtitle-text">
          Discover expert global trade analyses, ceramic cluster reports,
          sustainable building practices, and construction technology
          innovations.
        </p>

        {/* Category Pills Row */}
        <div className="category-tabs-row">
          {categories.map((cat) => (
            <button
              key={cat}
              className={`cat-tab-pill ${activeCategory === cat ? "active" : ""}`}
              onClick={() => setActiveCategory(cat)}
            >
              {cat === "All" ? "All Blogs" : cat}
            </button>
          ))}
        </div>
      </section>

      {/* 3-COLUMN BLOG CARDS GRID */}
      <section className="blogs-grid-container">
        <div className="blogs-card-grid">
          {filteredBlogs.map((blog) => (
            <div key={blog.id} className="blog-card-slot">
              <div className="blog-item-card">
                <div className="card-img-wrapper">
                  <img
                    src={blog.image}
                    alt={blog.title}
                    className="card-thumb-img"
                  />
                </div>

                <div className="card-body-section">
                  <div>
                    <h3 className="card-blog-title">{blog.title}</h3>
                    <p className="card-blog-excerpt">{blog.excerpt}</p>
                  </div>

                  <div className="card-footer-bar">
                    <button
                      className="read-link-btn"
                      onClick={() => setSelectedBlog(blog)}
                    >
                      Read More <FaArrowRight className="btn-arrow-icon" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* REACT-MODAL POPUP */}
      <Modal
        isOpen={Boolean(selectedBlog)}
        onRequestClose={() => setSelectedBlog(null)}
        contentLabel={selectedBlog?.title || "Blog Details"}
        className="blog-modal-card"
        overlayClassName="blog-modal-backdrop"
        closeTimeoutMS={250}
      >
        {selectedBlog && (
          <>
            <button
              className="modal-close-btn"
              onClick={() => setSelectedBlog(null)}
              title="Close article"
            >
              <FaXmark />
            </button>

            <div className="modal-header-image-box">
              <img
                src={selectedBlog.image}
                alt={selectedBlog.title}
                className="modal-img"
              />
            </div>

            <div className="modal-body-content">
              <h2 className="modal-blog-title">{selectedBlog.title}</h2>
              <p className="modal-text-content">{selectedBlog.content}</p>
            </div>
          </>
        )}
      </Modal>
    </div>
  );
};

export default Blogs;
